import { ReactNode } from "react";

import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

export enum StackRolesBulkActions {
  Unassign = "Unassign",
}

export type StackRolesBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
  metadata: Record<string, string | boolean>;
};

export type StackRolesMutationVariables = null;

export type StackRolesBulkActionItem = BulkEntityActionItem<
  StackRolesBulkActions,
  StackRoleBindingView,
  StackRolesMutationVariables
>;

export type StackRolesBulkActionsConfirmActionStepProps = {
  bulkActionsVariant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: StackRolesMutationVariables,
    analyticsPayload: StackRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  action: StackRolesBulkActionItem;
  customConfirmationMessage?: ReactNode;
};
